package app.credit

val statusValues = arrayListOf(
        "Դիմում",
        "Ընթացիկ",
        "Հաստատաված",
        "Տրամադրված",
        "Մերժված",
        "Հրաժարված"
)